import fetch from '../../../../utils/fetch'

const getInitialState = () => {
  return {
    isLoading: false,
    isLoaded: false,
    totalProjects: 0,
    featuredProjects: 0,
    publishedProjects: 0,
    draftProjects: 0,
    error: null,
  }
}

const state = getInitialState()

const getters = {
  isLoading(state) {
    return state.isLoading
  },
  isLoaded(state) {
    return state.isLoaded
  },
  totalProjects(state) {
    return state.totalProjects
  },
  featuredProjects(state) {
    return state.featuredProjects
  },
  publishedProjects(state) {
    return state.publishedProjects
  },
  draftProjects(state) {
    return state.draftProjects
  },
  error(state) {
    return state.error
  },
  stats(state) {
    return {
      totalProjects: state.totalProjects,
      featuredProjects: state.featuredProjects,
      publishedProjects: state.publishedProjects,
      draftProjects: state.draftProjects,
    }
  },
}

const actions = {
  /**
   * @function getStats - Fetch admin dashboard statistics
   * @param {Object} context - Vuex context
   * @param {boolean} force - Force refresh even if already loaded
   * @returns {Promise}
   */
  async getStats({ commit, state }, force = false) {
    // Skip if already loaded unless force refresh
    if (state.isLoaded && !force) {
      return
    }
    
    commit(types.SET_LOADING)
    
    try {
      const [allProjects, featured, published, drafts] = await Promise.all([
        fetch('/projects?itemsPerPage=1').then(r => r.json()),
        fetch('/projects?isFeatured=true&itemsPerPage=1').then(r => r.json()),
        fetch('/projects?projectState=1&itemsPerPage=1').then(r => r.json()),
        fetch('/projects?projectState=0&itemsPerPage=1').then(r => r.json()),
      ])
      
      commit(types.SET_STATS, {
        totalProjects: allProjects['hydra:totalItems'] || 0,
        featuredProjects: featured['hydra:totalItems'] || 0,
        publishedProjects: published['hydra:totalItems'] || 0,
        draftProjects: drafts['hydra:totalItems'] || 0,
      })
    } catch (error) {
      commit(types.SET_ERROR, error)
    }
  },
  
  /**
   * @function refresh - Reset stats state
   * @param {Object} context - Vuex context
   */
  refresh({ commit }) {
    commit(types.RESET)
  },
}

const types = {
  SET_LOADING: 'SET_LOADING',
  SET_STATS: 'SET_STATS',
  SET_ERROR: 'SET_ERROR',
  RESET: 'RESET',
}

const mutations = {
  [types.SET_LOADING](state) {
    state.isLoading = true
    state.error = null
  },
  [types.SET_STATS](state, stats) {
    state.totalProjects = stats.totalProjects
    state.featuredProjects = stats.featuredProjects
    state.publishedProjects = stats.publishedProjects
    state.draftProjects = stats.draftProjects
    state.isLoading = false
    state.isLoaded = true
  },
  [types.SET_ERROR](state, error) {
    state.error = error
    state.isLoading = false
  },
  [types.RESET](state) {
    Object.assign(state, getInitialState())
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
